export default __webpack_public_path__ + "static/media/y.e55b9438.svg";